export const PUPPY_COLLEGE_ENTITLEMENT = 'puppy_college';
